import { render, staticRenderFns } from "./ProductivityReports.vue?vue&type=template&id=0aa51c01&scoped=true&"
import script from "./ProductivityReports.vue?vue&type=script&lang=js&"
export * from "./ProductivityReports.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityReports.vue?vue&type=style&index=0&id=0aa51c01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa51c01",
  null
  
)

export default component.exports